// import React, { useEffect, useState } from 'react';
// import { Button, Datepick, Flex, Flexed, Input, Label, Textauto } from '../../utilities/Shared';
// import axios from 'axios';
// import { v4 as uuidv4 } from 'uuid';
// import { toast } from 'react-toastify';

// const Editfollow = ({ customer, onCancel, reset, setReset, setCustomer, updateCustomerList }) => {
//   const [contact, setContact] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     note: '',
//   });
//   const [follodate, setFollodate] = useState();
//   const [error, setError] = useState(null);
//   const [saving, setSaving] = useState(false);
//   const [folos, setFolos] = useState(customer?.followup || []);
//   // Initialize state when customer changes or modal reopens
//   useEffect(() => {
//     const newFollodate = customer?.followup?.date ? new Date(customer.followup.date) : "";
 
//     const newContact = {
//       name: customer?.followup?.name || '',
//       email: customer?.followup?.email || '',
//       phone: customer?.followup?.phone || '',
//       note: customer?.followup?.note || '',
//     };
//     setFollodate(newFollodate);
//     setContact(newContact);
//     console.log('Editfollow initialized with customer:', {
//       customerId: customer?._id,
//       followup: customer?.followup,
//       newContact,
//       newFollodate,
//     });
//   }, [customer]);

//   // Handle contact selection from datalist
//   const setitem = (e) => {
//     const inputValue = e.target.value;
//     const selectedContact = customer?.contacts?.find((contact) => contact.name === inputValue);
//     console.log(selectedContact)
//     if (selectedContact) {
//       setContact({
//         name: selectedContact.name,
//         email: selectedContact.email,
//         phone: selectedContact.officephone,
//         note: contact.note || '',
//       });
//     } else {
//       setContact({ ...contact, name: inputValue, email: '', phone: '', id: null });
//     }
//   };

//   // Save follow-up data
//   const saveit = async () => {

//     console.log()
//     if (saving) return;
//     if (!customer?._id) {
//       setError('Invalid customer ID');
//       return;
//     }

//     setSaving(true);
//     const newfolo = {
//       name: contact.name,
//       phone: contact.phone,
//       email: contact.email,
//       date: follodate,
//       note: contact.note,
//     };
   
// let h = [...folos,newfolo]
// const payload = {
//     id: customer._id,
//     field: 'followup',
//     value: h,
//   };"AxiosError: Network Error\n    at XMLHttpRequest.<anonymous> (https://dash.highgroundsoftware.com/static/js/main.780bfef9.js:2:740708)"

//     //try {
//       const res = await axios.post('http://localhost:5003/customers/update/field', payload, {
//         validateStatus: (status) => status >= 200 && status < 300,
//       });
//       console.log('Save response:', {
//         status: res.status,
//         data: res.data,
//       });

//       // Update parent states
//       if (typeof updateCustomerList === 'function') {
//       setCustomer(res.data);

//       }
//     //   if (typeof updateCustomerList === 'function') {
//     //     updateCustomerList(res.data);
//     //   } else {
//     //     console.warn('updateCustomerList is not a function');
//     //   }
//       setReset(!reset);
//       setError(null);
//       setSaving(false);
//       onCancel();
//    // } catch (err) {
//     //   console.error('Error saving follow-up:', {
//     //     message: err.message,
//     //     response: err.response ? {
//     //       status: err.response.status,
//     //       data: err.response.data,
//     //     } : null,
//     //   });
//     //   setError(err.response?.data?.message || 'Failed to save follow-up. Please try again.');
//       setSaving(false);
//     //}
//   };


//   useEffect(() => {
//     if (
//         contact.name === '' &&
//         contact.email === '' &&
//         contact.phone === '' &&
//         contact.note === '' &&
//         follodate === null
//     ) {
//         saveit();
//     }
// }, [contact, follodate]);


// const clearfollow = () => {
//     setContact({
//         name: '',
//         email: '',
//         phone: '',
//         note: '',
//     });
//     setFollodate(null);
// }


//     const addNewContact = async(e) => {
// e.preventDefault()

// let newinfo = {
//   invoices:false,
//   contactid:uuidv4(),
//   name:contact.name,
//   officephone:contact.phone,
//   email:contact.email,  
// }
// const y = {
//     customerid:customer._id,
//     info:newinfo
// }


//        // await axios.post(`https://highgroundapi.herokuapp.com/customers/addcontact`,y)
//         await axios.post(`http://localhost:5003/customers/addcontact`,y)
//         .then(res => {console.log(res.data);toast.success('Contact Added');setReset(!reset)})
//         .then(resp => {
//        console.log(y.info.name)
//        setContact({ ...contact, name: y.info.name, email: '', phone: '', id: null });
      
       
//         })
//         .catch(err  => console.log(err))
   
//     }




//   return (
//     <div>
//       <Flexed>
//         <Flex fontSize="calc(1.2rem + .2vw)" textAlign="center">
//           Follow Up info for {customer?.name}
//         </Flex>
//       </Flexed>
//       {error && (
//         <Flexed padding="10px">
//           <Flex color="red">{error}</Flex>
//         </Flexed>
//       )}
//       <Flexed gap="5px" padding="10px 0px">
//         <Flex>
//           <Label>Contact</Label>
//           <br />
//           <Input type="text" value={contact.name} list="listid" onChange={setitem} disabled={saving} />
//           <datalist id="listid">
//             {customer?.contacts?.map((item, index) => (
//               <option
//                 key={index}
//                 data-item={item.contactid}
//                 data-name={item.name}
//                 data-email={item.email}
//                 data-phone={item.officephone}
//                 value={item?.name}
//               />
//             ))}
//           </datalist>
//         </Flex>
//         <Flex>
//           <Label>Phone</Label>
//           <br />
//           <Input
//             value={contact.phone}
//             onChange={(e) => setContact({ ...contact, phone: e.target.value })}
//             disabled={saving}
//           />
//         </Flex>
//         <Flex>
//           <Label>Email</Label>
//           <br />
//           <Input
//             value={contact.email}
//             onChange={(e) => setContact({ ...contact, email: e.target.value })}
//             disabled={saving}
//           />
//           {
//             customer.contacts.some(name => name.name === contact.name) ? null : <> <br /><span style={{display:"flex",justifyContent:"flex-end"}}><Button color="green" onClick={e => addNewContact(e)}>Save to Contacts</Button></span></> 
//           }
         
//         </Flex>
//         <Flex flex=".5">
//           <Label>Follow Up Date</Label>
//           <br />
//           <Datepick
//             fontWeight="bold"
//             selected={follodate}
//             onChange={(date) => setFollodate(date)}
//             disabled={saving}
//           />
//         </Flex>
//       </Flexed>
//       <Flexed gap="5px" padding="10px 0px">
//         <Flex>
//           <Label>Note:</Label>
//           <Textauto
//             color="black"
//             minRows="5"
//             value={contact.note}
//             onChange={(e) => setContact({ ...contact, note: e.target.value })}
//             disabled={saving}
//           />
//         </Flex>
//       </Flexed>
//       <Flexed>
//         <Flex textAlign="left" padding="20px 10px 20px 0px">
//             <Button color="red"
//             aria-label="Clear follow-up changes"
//             onClick={clearfollow}>Clear Follow Up</Button>
//         </Flex>
//         <Flex textAlign="right" padding="20px 10px 20px 0px">
//           <Button
//             color="green"
//             aria-label="Save follow-up changes"
//             onClick={saveit}
//             disabled={saving}
//           >
//             {saving ? 'Saving...' : 'Save Edit'}
//           </Button>
//         </Flex>
//       </Flexed>
//     </div>
//   );
// };

// export default Editfollow;



import React, { useEffect, useState } from 'react';
import { Button, Datepick, Flex, Flexed, Input, Label, Textauto } from '../../utilities/Shared';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';

const Editfollow = ({ customer, onCancel, reset, setReset, setCustomer, updateCustomerList }) => {
  const [contact, setContact] = useState({
    name: '',
    email: '',
    phone: '',
    note: '',
  });
  const [follodate, setFollodate] = useState(null);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [folos, setFolos] = useState(customer?.followup || []);

  // Initialize state when customer changes
  useEffect(() => {
    const newFollodate = customer?.followup?.date ? new Date(customer.followup.date) : null;
    const newContact = {
      name: contact.name || customer?.followup?.name || '',
      email: contact.email || customer?.followup?.email || '',
      phone: contact.phone || customer?.followup?.phone || '',
      note: contact.note || customer?.followup?.note || '',
    };
    setFollodate(newFollodate);
    setContact(newContact);
    console.log('Editfollow initialized with customer:', {
      customerId: customer?._id,
      followup: customer?.followup,
      newContact,
      newFollodate,
    });
  }, [customer]);

  // Handle contact selection from datalist
  const setitem = (e) => {
    const inputValue = e.target.value;
    const selectedContact = customer?.contacts?.find((contact) => contact.name === inputValue);
    if (selectedContact) {
      setContact({
        name: selectedContact.name,
        email: selectedContact.email,
        phone: selectedContact.officephone,
        note: contact.note || '',
      });
    } else {
      setContact({ ...contact, name: inputValue, email: '', phone: '', id: null });
    }
  };

  // Save follow-up data
  const saveit = async () => {
    if (saving) return;
    if (!customer?._id) {
      setError('Invalid customer ID');
      return;
    }

    setSaving(true);
    const newfolo = {
      name: contact.name,
      phone: contact.phone,
      email: contact.email,
      date: follodate,
      note: contact.note,
    };

    let h = [...folos, newfolo];
    const payload = {
      id: customer._id,
      field: 'followup',
      value: h,
    };

    try {
      const res = await axios.post('https://highgroundapi.herokuapp.com/customers/update/field', payload, {
        validateStatus: (status) => status >= 200 && status < 300,
      });
      console.log('Save response:', {
        status: res.status,
        data: res.data,
      });

      // Update parent states
      //setCustomer(res.data);
      if (typeof updateCustomerList === 'function') {
        updateCustomerList(res.data);
      } else {
        console.warn('updateCustomerList is not a function');
      }
      setReset(!reset);
      setError(null);
      onCancel();
    } catch (err) {
      console.error('Error saving follow-up:', {
        message: err.message,
        response: err.response ? {
          status: err.response.status,
          data: err.response.data,
        } : null,
      });
      setError(err.response?.data?.message || 'Failed to save follow-up. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  // Clear follow-up form
  const clearfollow = () => {
    setContact({
      name: '',
      email: '',
      phone: '',
      note: '',
    });
    setFollodate(null);
  };

  // Add new contact
  const addNewContact = async (e) => {
    e.preventDefault();

    if (saving) return;
    setSaving(true);

    const newinfo = {
      invoices: false,
      contactid: uuidv4(),
      name: contact.name,
      officephone: contact.phone,
      email: contact.email,
    };

    const payload = {
      customerid: customer._id,
      info: newinfo,
    };

    try {
      const res = await axios.post('https://highgroundapi.herokuapp.com/customers/addcontact', payload);
      console.log('Add contact response:', res.data);
      toast.success('Contact Added');
      setReset(!reset);
      // Update customer state with new contact
      const updatedCustomer = {
        ...customer,
        contacts: [...(customer.contacts || []), newinfo],
      };
      setCustomer(updatedCustomer);
      if (typeof updateCustomerList === 'function') {
        updateCustomerList(updatedCustomer);
      }

      // Preserve modal state
      setContact({
        ...contact,
        name: newinfo.name,
        email: newinfo.email,
        phone: newinfo.officephone,
      });
      
    } catch (err) {
      console.error('Error adding contact:', err);
     
    } finally {
      setSaving(false);
      
    }
  };

  return (
    <div>
      <Flexed>
        <Flex fontSize="calc(1.2rem + .2vw)" textAlign="center">
          Follow Up info for {customer?.name}
        </Flex>
      </Flexed>
      {error && (
        <Flexed padding="10px">
          <Flex color="red">{error}</Flex>
        </Flexed>
      )}
      <Flexed gap="5px" padding="10px 0px">
        <Flex>
          <Label>Contact</Label>
          <br />
          <Input type="text" value={contact.name} list="listid" onChange={setitem} disabled={saving} />
          <datalist id="listid">
            {customer?.contacts?.map((item, index) => (
              <option
                key={index}
                data-item={item.contactid}
                data-name={item.name}
                data-email={item.email}
                data-phone={item.officephone}
                value={item?.name}
              />
            ))}
          </datalist>
        </Flex>
        <Flex>
          <Label>Phone</Label>
          <br />
          <Input
            value={contact.phone}
            onChange={(e) => setContact({ ...contact, phone: e.target.value })}
            disabled={saving}
          />
        </Flex>
        <Flex>
          <Label>Email</Label>
          <br />
          <Input
            value={contact.email}
            onChange={(e) => setContact({ ...contact, email: e.target.value })}
            disabled={saving}
          />
          {!customer?.contacts?.some((c) => c.name === contact.name) && (
            <>
              <br />
              <span style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button color="green" onClick={addNewContact} disabled={saving}>
                  Save to Contacts
                </Button>
              </span>
            </>
          )}
        </Flex>
        <Flex flex=".5">
          <Label>Follow Up Date</Label>
          <br />
          <Datepick
            fontWeight="bold"
            selected={follodate}
            onChange={(date) => setFollodate(date)}
            disabled={saving}
          />
        </Flex>
      </Flexed>
      <Flexed gap="5px" padding="10px 0px">
        <Flex>
          <Label>Note:</Label>
          <Textauto
            color="black"
            minRows="5"
            value={contact.note}
            onChange={(e) => setContact({ ...contact, note: e.target.value })}
            disabled={saving}
          />
        </Flex>
      </Flexed>
      <Flexed>
        <Flex textAlign="left" padding="20px 10px 20px 0px">
          <Button
            color="red"
            aria-label="Clear follow-up changes"
            onClick={clearfollow}
            disabled={saving}
          >
            Clear Follow Up
          </Button>
        </Flex>
        <Flex textAlign="right" padding="20px 10px 20px 0px">
          <Button
            color="green"
            aria-label="Save follow-up changes"
            onClick={saveit}
            disabled={saving}
          >
            {saving ? 'Saving...' : 'Save Edit'}
          </Button>
        </Flex>
      </Flexed>
    </div>
  );
};

export default Editfollow;

